import React, { useEffect, useState } from "react";
import { ArrowUpRight, Menu, X } from "lucide-react";
import logo from "../assets/planimex-logo.png";
import { NAV_LINKS } from "../mock/mock";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { color } from "framer-motion";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollToHash = (href) => {
    const target = href || "#top";

    if (target === "#top") {
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }

    const id = target.replace("#", "");
    const el = document.getElementById(id);
    if (el) {
      const topOffset = 96;
      const y = el.getBoundingClientRect().top + window.scrollY - topOffset;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  };

  const go = (href) => {
    setOpen(false);

    if (!href.startsWith("#")) {
      navigate(href);
      return;
    }

    const targetHash = href === "#top" ? "#top" : href;

    if (location.pathname !== "/") {
      navigate({ pathname: "/", hash: targetHash });
      return;
    }

    if (window.location.hash !== targetHash) {
      window.history.pushState({}, "", `/${targetHash}`);
    }

    requestAnimationFrame(() => scrollToHash(targetHash));
  };

  return (
    <header
      className={`fixed top-0 inset-x-0 z-[1000] transition-all duration-500 ${
        scrolled
          ? "bg-[#111111]/95 backdrop-blur-md border-b border-[#2b2720]"
          : "bg-[#111111]/85 backdrop-blur-sm border-b border-transparent"
      }`}
    >
      <div className="section-pad flex h-[72px] items-center justify-between">
        <a href="#top" onClick={(e) => { e.preventDefault(); go("#top"); }} className="flex items-center">
          <img src={logo} alt="Planimex" className="h-[40px] w-auto select-none" draggable={false} />
        </a>

        <nav className="hidden items-center gap-9 lg:flex">
          {NAV_LINKS.map((l) => (
            l.href.startsWith("#") ? (
              <button
                key={l.label}
                onClick={() => go(l.href)}
                className="mono-label link-underline transition-colors"
                style={{ opacity: "1", color: "white" }}
              >
                {l.label}
              </button>
            ) : (
              <Link
                key={l.label}
                to={l.href}
                className="mono-label link-underline transition-colors"
                style={{ opacity: "1", color: "white" }}
              >
                {l.label}
              </Link>
            )
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            onClick={() => go("#contact")}
            className="hidden items-center gap-2 border border-[#5e5649] px-5 py-2.5 mono-label !text-[#f3f1eb] transition-all duration-300 hover:bg-[#f3f1eb] hover:!text-[#111111] sm:inline-flex"
          >
            CERE OFERTĂ
            <ArrowUpRight size={14} strokeWidth={1.75} />
          </button>
          <button className="p-1 text-[#f3f1eb] lg:hidden" onClick={() => setOpen((v) => !v)} aria-label="Meniu">
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      <div
        className={`lg:hidden overflow-hidden transition-all duration-500 bg-[#111111]/96 backdrop-blur-md ${
          open ? "max-h-[420px] border-t border-[#2b2720]" : "max-h-0"
        }`}
      >
        <div className="section-pad flex flex-col gap-5 py-6">
          {NAV_LINKS.map((l) =>
            l.href.startsWith("#") ? (
              <button key={l.label} onClick={() => go(l.href)} className="mono-label text-left text-white" 
                style={{ opacity: "1", color: "white" }}>
                {l.label}
              </button>
            ) : (
              <Link key={l.label} to={l.href} onClick={() => setOpen(false)} className="mono-label text-left text-[#f3f1eb]"
                style={{ opacity: "1", color: "white" }}>
                {l.label}
              </Link>
            )
          )}
          <button onClick={() => go("#contact")} className="mt-2 inline-flex w-fit items-center gap-2 border border-[#5e5649] px-5 py-2.5 mono-label !text-[#f3f1eb] transition-all duration-300 hover:bg-[#f3f1eb] hover:!text-[#111111]">
            CERE OFERTĂ <ArrowUpRight size={14} />
          </button>
        </div>
      </div>
    </header>
  );
}
